<template>
  <div class="section-wrap">
    <div class="multi-item-title mt-40">
      <h3 class="section-title">희망 활동(근무) 조건</h3>
      <div class="check-util">
        <div class="check-wrap"><input type="checkbox" id="prefInfo" v-model="prefInfoUseYn" true-value="N" false-value="Y" title="무관(선호 조건 없음) 선택"><label for="prefInfo"><span>무관(선호 조건 없음)</span></label></div>
        <button type="button" class="btn btn-line-box btn-sm" @click="resetPreferences">
          <i class="ico ico-refresh"></i>
          입력항목 초기화
        </button>
      </div>
    </div>
    <div class="table-wrap mt-16">
      <table class="table-body-only">
        <caption>희망 활동(근무)조건 테이블</caption>
        <colgroup class="pc-cell">
          <col style="width: 160px;" />
          <col />
        </colgroup>
        <colgroup class="mo-cell">
          <col style="width: 88px;" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">업직종</th>
            <td>
              <div class="input-area mo-size wid400">
              <select title="희망 직종 선택" v-model="preferences.desiredOccupationCd" :disabled="isDisabled">
                <option value="">희망 직종 선택</option>
                <option v-for="item in codes.desiredOccupationCodes" :value="item.code" :key="item.code">{{ item.name }}</option>
              </select>
              </div>
              ※ 현재 설정된 나의 업직종은 <strong>'{{ savedOccupationName }}'</strong> 입니다.
            </td>
          </tr>
          <tr>
            <th scope="row">희망시급</th>
            <td>
              <div class="input-area mo-size wid400">
              <select title="희망 급여 선택" v-model="preferences.desiredSalaryRange" :disabled="isDisabled">
                <option value="">희망 급여 선택</option>
                <option v-for="item in codes.desiredSalaryRanges" :value="item.code" :key="item.code">{{ item.name }}</option>
              </select>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">고용형태</th>
            <td>
              <div class="input-area mo-size wid400">
              <select title="고용형태 선택" v-model="preferences.desiredEmploymentTypeCd" :disabled="isDisabled">
                <option value="">고용형태 선택</option>
                <option v-for="item in codes.desiredEmploymentTypeCodes" :value="item.code" :key="item.code">{{ item.name }}</option>
              </select>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">희망근무지역</th>
            <td>
              <div class="check-group" id="preferences">
                <div class="check-wrap" v-for="item in codes.desiredWorkRegions" :key="item.code">
                  <input type="checkbox" :id="`region_${item.code}`" :value="item.code" :checked="isChecked(item.code)" @change="handleRegionChange($event, item.code)" :disabled="isDisabled" title="선택 선택">
                  <label :for="`region_${item.code}`"><span>{{ item.name }}</span></label>
                </div>
              </div>
              <div class="mt-16">* 현재 설정된 거주지(주소)는 <strong>‘{{ district }}’</strong> 입니다.</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Axios from 'axios';
import { apiHandler } from './resume-common';

export default({
  name: 'preferences-modal-template',
  props: ['preferencesModal', 'indbankNo', 'district', 'codes'],
  data() {
    return {
      preferences: { },
      desiredWorkRegionArray: [], // 체크박스 상태 관리용 배열
      savedOccupationCd: '', // 저장된 업직종 코드 (실시간 변경 방지)
      prefInfoUseYn: 'Y', // 기본값: Y - 선호 조건 있음
      isDisabled: false, // 입력 필드 비활성화 상태
    };
  },
  computed: {
    currentOccupationName() {
      if (!this.preferences.desiredOccupationCd || !this.codes.desiredOccupationCodes) {
        return '설정되지 않음';
      }

      const occupation = this.codes.desiredOccupationCodes.find(
        item => item.code === this.preferences.desiredOccupationCd,
      );

      return occupation ? occupation.name : this.preferences.desiredOccupationCd;
    },
    savedOccupationName() {
      if (!this.savedOccupationCd || !this.codes.desiredOccupationCodes) {
        return '설정되지 않음';
      }

      const occupation = this.codes.desiredOccupationCodes.find(
        item => item.code === this.savedOccupationCd,
      );

      return occupation ? occupation.name : this.savedOccupationCd;
    },
  },
  watch: {
    preferencesModal: {
      handler(newVal) {
        if (newVal && this.indbankNo) {
          this.getPreferences();
          this.getBasic();
        }
      },
      immediate: true,
    },
    prefInfoUseYn: {
      handler(newVal) {
        this.isDisabled = (newVal === 'N');
      },
    },
  },
  methods: {
    getBasic() {
      Axios.get(`/api/idb/${this.indbankNo}/basic`).then((response) => {
        if (response.data.success === 'R') {
          this.prefInfoUseYn = response.data.data.prefInfoUseYn || 'Y'; // 값이 없으면 기본값 'Y' 설정
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    getPreferences() {
      Axios.get(`/api/idb/${this.indbankNo}/preferences`).then((response) => {
        if (response.data.success === 'R') {
          this.preferences = response.data.data;
          if (!this.preferences.desiredOccupationCd) this.preferences.desiredOccupationCd = '';
          if (!this.preferences.desiredSalaryRange) this.preferences.desiredSalaryRange = '';
          if (!this.preferences.desiredEmploymentTypeCd) this.preferences.desiredEmploymentTypeCd = '';

          // 저장된 업직종 코드 별도 보관 (실시간 변경 방지)
          this.savedOccupationCd = this.preferences.desiredOccupationCd;

          // 쉼표로 구분된 문자열을 배열로 변환
          if (this.preferences.desiredWorkRegion) {
            this.desiredWorkRegionArray = this.preferences.desiredWorkRegion.split(',').map(region => region.trim());
          } else {
            this.desiredWorkRegionArray = [];
          }
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    isChecked(code) {
      return this.desiredWorkRegionArray && this.desiredWorkRegionArray.includes(code);
    },
    handleRegionChange(event, code) {
      const isChecked = event.target.checked;

      if (isChecked) {
        // 체크박스를 선택하려고 할 때
        if (this.desiredWorkRegionArray.length > 4) {
          // 이미 4개가 선택되어 있으면 선택을 막고 alert 표시
          alert('희망 근무지역은 최대 4개까지 선택 하실 수 있습니다.');
          // DOM 조작 대신 nextTick을 사용하여 Vue의 반응성 시스템과 동기화
          this.$nextTick(() => {
            const checkbox = document.getElementById(`region_${code}`);
            if (checkbox) {
              checkbox.checked = false;
            }
          });
          return;
        }
        // 4개 미만이면 배열에 추가
        this.desiredWorkRegionArray.push(code);
      } else {
        // 체크박스를 해제할 때
        const index = this.desiredWorkRegionArray.indexOf(code);
        if (index > -1) {
          this.desiredWorkRegionArray.splice(index, 1);
        }
      }
    },
    updatePreferences() {
      if (this.vaildCheck() && confirm('저장하시겠습니까?')) {
        // Vue.js 데이터 바인딩을 활용한 체크박스 값들 수집
        const checkedRegions = this.desiredWorkRegionArray;

        // 배열을 쉼표로 구분된 문자열로 변환
        const preferencesData = {
          ...this.preferences,
          desiredWorkRegion: checkedRegions.length > 0 ? checkedRegions.join(',') : '',
        };

        Axios.post(`/api/idb/${this.indbankNo}/preferences`, {
          ...preferencesData,
          prefInfoUseYn: this.prefInfoUseYn
        }).then((response) => {
          apiHandler.handleSaveSuccess(response, (res) => {
            // 완성도 업데이트 (올바른 경로로 접근)
            if (res.data && res.data.data.completionRate !== undefined) {
              this.$emit('update:CompletionRate', res.data.data.completionRate);
            }

            // 저장 성공시 저장된 업직종 코드 업데이트 (텍스트 갱신)
            this.$set(this, 'savedOccupationCd', this.preferences.desiredOccupationCd);

            // 로컬 상태 업데이트
            this.desiredWorkRegionArray = checkedRegions;
          });
        }).catch((e) => {
          apiHandler.handleError(e);
        });
      }
    },
    vaildCheck() {
      // 선호 조건 없음이 체크된 경우 유효성 검사 생략
      if (this.prefInfoUseYn === 'N') return true;

      // 선호 조건 없음이 미체크된 경우 하나라도 입력되어 있어야 함
      const hasOccupation = this.preferences.desiredOccupationCd && this.preferences.desiredOccupationCd !== '';
      const hasSalary = this.preferences.desiredSalaryRange && this.preferences.desiredSalaryRange !== '';
      const hasEmploymentType = this.preferences.desiredEmploymentTypeCd && this.preferences.desiredEmploymentTypeCd !== '';
      const hasWorkRegion = this.desiredWorkRegionArray && this.desiredWorkRegionArray.length > 0;

      // 하나라도 입력되어 있으면 통과
      if (hasOccupation || hasSalary || hasEmploymentType || hasWorkRegion) {
        return true;
      }

      // 모든 항목이 비어있으면 알림 표시
      alert('희망 조건을 선택하세요.');
      return false;
    },
    resetPreferences() {
      const message = '해당화면의 작성 중인 내용이 사라집니다.\n입력하신 내용을 초기화 하시겠습니까?';

      if (confirm(message)) {
        // 희망 활동 조건 데이터 초기화
        this.preferences = {
          desiredOccupationCd: '',
          desiredSalaryRange: '',
          desiredEmploymentTypeCd: '',
          desiredWorkRegion: ''
        };

        // 희망근무지역 배열 초기화
        this.desiredWorkRegionArray = [];

        // 선호 조건 없음 체크박스 초기화 (기본값: Y - 선호 조건 있음)
        this.prefInfoUseYn = 'Y';

        // 비활성화 상태 초기화
        this.isDisabled = false;

        // 저장된 업직종 코드 초기화
        this.savedOccupationCd = '';
      }
    },
  },
});
</script>



// WEBPACK FOOTER //
// Preferences.vue?d3a80cbc